import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Planet({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M7.72976 12C7.72976 9.64 9.63976 7.73 11.9898 7.73M22.7898 5.76C23.9298 7.74 20.0298 12.15 14.0598 15.59C8.08976 19.03 2.31976 20.21 1.17976 18.22M1.19976 18.24C0.499762 17.03 1.66976 14.93 4.02976 12.69M16.5898 5.45C19.6998 4.52 22.0998 4.56 22.7998 5.76M11.9998 4C9.87803 4 7.8432 4.84285 6.34291 6.34315C4.84262 7.84344 3.99976 9.87827 3.99976 12C3.99976 14.1217 4.84262 16.1566 6.34291 17.6569C7.8432 19.1571 9.87803 20 11.9998 20C14.1215 20 16.1563 19.1571 17.6566 17.6569C19.1569 16.1566 19.9998 14.1217 19.9998 12C19.9998 9.87827 19.1569 7.84344 17.6566 6.34315C16.1563 4.84285 14.1215 4 11.9998 4Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Planet;